export const statusesType = [
  { id: 1, key: 'entitlements_permits', label: 'Entitlements & Permits' },
  { id: 2, key: 'design', label: 'Design' },
  { id: 3, key: 'construction', label: 'Construction' },
  { id: 4, key: 'budget', label: 'Budget' },
  { id: 5, key: 'owner_items', label: 'Owner Items' },
  { id: 6, key: 'other', label: 'Other' },
];
